import { get, post, put, del } from 'services/request.service';
import { getEnv } from 'services/apiEnv.service';
import { TAPIArgs } from 'api/api.types';

const BASE_URL = `${getEnv('IT_BASE_URL')}/api`;

export const searchDevopsProjects = async ({ params }: TAPIArgs = {}) => {
  const response = await get({ url: `${BASE_URL}/search`, params });

  return {
    data: response?.data
  };
};

export const addRequestToDevops = async ({ data }: any) => {
  return (
    await post({
      url: `${BASE_URL}/requests/azure-devops-workitem-add`,
      data,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      }
    })
  ).data;
};
